export function formatTextAsHTMLList(input: string): string {
  if (!input) return "";

  if (/<(ul|ol)[\s>]/i.test(input)) {
    return input;
  }

  const items = input.includes("\n")
    ? input.split("\n").map(i => i.trim()).filter(Boolean)
    : input.split(",").map(i => i.trim()).filter(Boolean);

  if (!items.length) return "";

  const html = `<ul>
${items.map(item => `  <li>${item}</li>`).join("\n")}
</ul>`;

  return html;
}


export function ensureRequirementsList(input: string): string {
  if (!input) return "";

  if (/<(ul|ol)[\s>]/i.test(input)) {
    return input;
  }
  const items = input
    .split("\n")
    .map(line => line.replace(/^[\s\-•*·]+/, "").trim())
    .filter(Boolean);

  if (!items.length) return "";


  const html = `<ul>
    ${items.map(item => `  <li>${item}</li>`).join("\n")}
    </ul>`;

  return html;
}